
import { Download, Heart } from 'react-feather';
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';

import { Campaign } from '../../Shared/types';
import { Card } from '../../Shared/UI/Card';
import { Icon } from '../../Shared/UI/Icon';
import { useRouter } from '../router';
import { Button, LinkButton } from '../UI/Button';

export default function DonationBoxQrCode({
  campaign,
}: {
  campaign: Campaign;
}) {
  const { t } = useTranslation();
  const { routes } = useRouter();

  const qrCodeUrl = `${campaign.donate_url}?utm_source=qr&utm_medium=customer&utm_campaign=donation_box_share`;

  const downloadQrCode = async () => {
    const svg = document.getElementById('donation_box_qr_code');

    if (svg) {
      const svgData = new XMLSerializer().serializeToString(svg);
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = function () {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx?.drawImage(img, 0, 0);
        const pngFile = canvas.toDataURL('image/png');

        const downloadLink = document.createElement('a');
        downloadLink.download = 'qrcode';
        downloadLink.href = `${pngFile}`;
        downloadLink.click();
      };

      img.src = 'data:image/svg+xml;base64,' + btoa(svgData);
    }
  };

  return (
    <Card shadow={false} border spacing="lg" className="text-center space-y-6">
      <h2 className="text-xl font-bold">
        {t('frontend:scan_and_donate')}
      </h2>

      <QRCode
        value={qrCodeUrl}
        size={1000}
        className="w-[200px] h-[200px] mx-auto"
        id="donation_box_qr_code"
      />

      <div>
        <Button
          onClick={() => downloadQrCode()}
          variant="secondary"
          size="sm"
          className="m-1"
        >
          <Icon className="mr-2">
            <Download />
          </Icon>
          {t('frontend:download_qr_code')}
        </Button>

        <LinkButton
          href={routes.donation_page(campaign.id)}
          size="sm"
          className="!font-bold m-1"
        >
          <Icon className="mr-2">
            <Heart />
          </Icon>
          {t('frontend:donate')}
        </LinkButton>

      </div>
    </Card>
  );
}
